<template>
	<section class="tooltip-content" v-if="type==='item'">
		<section class="item-head" v-bind:class="tierType[itemDef.inventory.tierType || 0].toLowerCase()">
			<img class="item-image" v-bind:src="'https://www.bungie.net'+itemDef.displayProperties.icon" />
			<h2 class="item-name">{{itemDef.displayProperties.name}} {{ data.itemHash }}</h2>
			<div>
				<span class="item-type">{{itemDef.itemTypeDisplayName || ""}}</span>
				<span class="item-rarity">{{tierType[itemDef.inventory.tierType || 0]}}</span>
			</div>
		</section>
		<section v-bind:class="['item-body',data.damageTypeHash&&DestinyDamageTypeDefinition[data.damageTypeHash].displayProperties.name.toLowerCase()]">
			<span v-if="data.primaryStat">
			<h1 class="item-primary-stat">{{data.primaryStat.value}}</h1>
			<div class="item-stat-text">{{DestinyStatDefinition[data.primaryStat.statHash].displayProperties.name}}</div>
		</span>
			<span v-else-if="data.quantity">
				<h1 class="item-primary-stat">{{ data.quantity || 1 }}</h1>
				<div class="item-stat-text">Quantity</div>
			</span>
			<span v-else-if="data.quantity">
				<h1 class="item-primary-stat">{{ data.quantity || 1 }}</h1>
				<div class="item-stat-text">Quantity</div>
			</span>
			<div class="item-description">{{itemDef.displayProperties.description}}</div>
		</section>
		<section class="item-stats" v-if="data.perks">
			<div class="item-perk" v-for="perk of data.perks" v-if="typeof perkDefinition(perk) !== 'undefined' && perk.visible === true">
				<img class="icon" v-bind:src="'https://www.bungie.net'+perkDefinition(perk).displayProperties.icon" />
				<div class="perk">
					<h3 class="name">{{ perkDefinition(perk).displayProperties.name }}</h3>
					<div class="description">{{ perkDefinition(perk).displayProperties.description }}</div>
				</div>
			</div>
		</section>
		<section class="item-stats" v-if="data.stats">
			<table>
				<tbody class="stat-table">
					<tr class="item-stat" v-for="stat of data.stats">
						<td class="stat-name">{{ DestinyStatDefinition[stat.statHash].statName }}</td>
						<td>
							<div class="remaining bar" v-bind:title="stat.value+' / '+getMaxRollForType(itemDef)"><span class="bar-full" v-bind:style="'width:'+statWidth(stat,itemDef)+'%'"></span></div>
						</td>
						<td class="stat-value">{{ stat.value }} <span v-bind:style="'color:'+getColor(statQuality(data,itemDef, stat.statHash))" v-if="stat.value > 0 && statQuality(data,itemDef, stat.statHash) > 0">({{ statQuality(data,itemDef, stat.statHash) }}%)</span>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<section class="item-stats" v-if="data.objectives">
			<table>
				<tbody class="stat-table">
					<tr class="item-stat" v-for="objective of data.objectives">
						<td class="stat-name">{{ objectiveDefinition(objective).displayDescription }}</td>
						<td>
							<div class="remaining bar" v-bind:title="objective.progress +' / '+ objectiveDefinition(objective).completionValue"><span class="bar-full" v-bind:style="'width:'+objectivePercentage(objective)+'%'"></span></div>
						</td>
						<td class="stat-value">{{ objective.progress }} / {{ objectiveDefinition(objective).completionValue }} <span v-if="objective.progress > 0 && objectivePercentage(objective) > 0">({{ objectivePercentage(objective) }}%)</span></td>
					</tr>
				</tbody>
			</table>
		</section>
		<!-- <section class="item-stats" v-if="data.stats">
			<table>
				<tbody class="stat-table">
					<tr class="item-stat" v-for="stat of data.stats">
						<td class="stat-name">{{ DestinyStatDefinition[stat.statHash].statName }}</td>
						<td>
							<div class="remaining bar" v-bind:title="stat.value+' / '+getMaxRollForType(itemDef)"><span class="bar-full" v-bind:style="'width:'+statWidth(stat,itemDef)+'%'"></span></div>
						</td>
						<td class="stat-value">{{ stat.value }} <span v-bind:style="'color:'+getColor(statQuality(data,itemDef, stat.statHash))" v-if="stat.value > 0 && statQuality(data,itemDef, stat.statHash) > 0">({{ statQuality(data,itemDef, stat.statHash) }}%)</span>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<section class="item-nodes" v-if="data.nodes && data.nodes.length">
			<table v-bind:data-json="JSON.stringify(getUINodes(false, data.nodes, data.talentGridHash))">
				<tbody class="node-table">
					<tr v-for="row of getUINodes(false, data.nodes, data.talentGridHash)">
						<td v-for="node of row">
							<div v-if="typeof node !== 'undefined'" v-bind:class="{node:true,'node-selected':node.isActivated,'node-complete':(9 === node.state || 1 === node.state || 5 === node.state || 6 === node.state)}"
							    v-bind:title="node.nodeStepName+' \n'+node.nodeStepDescription" v-bind:style="'background-image: url(https://www.bungie.net'+ node.icon +')'"></div>
							<div v-else class="node"></div>
						</td>
					</tr>
				</tbody>
			</table>
		</section>
		<section class="item-cost" v-if="data.costs">
			<table>
				<tbody class="cost-table">
					<tr v-for="cost of data.costs" class="item-stat cost">
						<td class="node" v-bind:style="'background-image:url(https://www.bungie.net'+itemDef.icon+')'">
							<td class="stat-name left-stat">{{itemDef.itemName}}</td>
							<td class="stat-name">{{cost.value}}</td>
						</td>
					</tr>
				</tbody>
			</table>
		</section> -->
	</section>
	<section class="tooltip-content" v-else-if="type==='progression'">
		<section class="item-head common">
			<img class="item-image" v-bind:src="'https://www.bungie.net' + getItemDef({itemHash:1460578929}).displayProperties.icon"
			    v-if="data.progressionHash === 540048094" />
			<img class="item-image" v-bind:src="'https://www.bungie.net'+itemDef.displayProperties.icon" v-else/>
			<h2 class="item-name">{{itemDef.displayProperties.name}}</h2>
			<div>
				<span class="item-type">Progression</span>
				<span class="item-rarity">Common</span>
			</div>
		</section>
		<section class="item-body">
			<span>
					<h1 class="item-primary-stat">{{data.currentProgress}}</h1>
					<div class="item-stat-text">{{itemDef.displayProperties.displayUnitsName}}</div>
				</span>
			<div class="item-description">{{itemDef.displayProperties.description}}</div>
		</section>
	</section>
	<section class="tooltip-content" v-else-if="type==='faction'">
		<section class="item-head common">
			<img class="item-image" v-bind:src="'https://www.bungie.net'+itemDef.displayProperties.icon" />
			<h2 class="item-name">{{itemDef.displayProperties.name}}</h2>
			<div>
				<span class="item-type">Faction</span>
				<span class="item-rarity">Common</span>
			</div>
		</section>
		<section class="item-body">
			<span>
				<h1 class="item-primary-stat">{{data.currentProgress}}</h1>
				<div class="item-stat-text">Reputation</div>
			</span>
			<div class="item-description">{{itemDef.displayProperties.description}}</div>
		</section>
	</section>
</template>

<style>
	.item-perk {
		margin-bottom: 0.1em;
	}

	.item-perk:first-child {
		background:rgba(255,255,255,0.1);
	}

	.icon {
		display: inline-block;
		width: 64px;
		height: 64px;
		margin-right: 5px;
		vertical-align: sub;
	}

	.perk {
		display: inline-block;
		vertical-align: top;
	}

	.name {
		display: inline-block;
		margin: 0.2em 0;
		font-size: 17px;
		font-weight: normal;
		color: white;
	}

	.perk .description {
		margin: 0.1em;
	}

	.popper {
		position: absolute;
		z-index: 200000;
		border: none;
		padding: 0;
		box-shadow: none;
		background: none;
	}

	.tooltip-content {
		/* position: absolute; */
		background: #1e242b;
		z-index: 999;
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		cursor: default;
		font-family: 'Roboto', sans-serif;
		font-size: 16px;
		font-weight: 400;
		display: inline-block;
		color: #F5F5F5;
		background: rgba(24, 22, 13, .85);
		box-shadow: 0 9px 25px rgba(0, 0, 0, .25);
		text-shadow: none;
		text-align: left;
		-webkit-font-smoothing: antialiased;
	}

	.tooltip-content.alt-tooltip {
		background: #490B22;
	}

	.tooltip-content .activity-title {
		text-align: center;
	}

	.tooltip-content .big-image {
		display: inline-block;
		vertical-align: middle;
	}

	.tooltip-content .title-categories {
		display: inline-block;
		vertical-align: middle;
		color: #fff;
		font-size: 18px;
		font-weight: 400;
		text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
		padding: 5px;
		background: rgba(255, 255, 255, 0.05);
	}

	.tooltip-content .title-categories span {
		display: block;
		text-align: center;
	}

	.tooltip-content .activity-skulls {
		margin-top: 10px;
		text-align: center;
	}

	.tooltip-content .activity-title .big-image {
		margin-right: 10px;
	}

	.tooltip-content .activity-skulls .skull-container {
		display: inline-block;
		margin-left: 5px;
		margin-right: 5px;
	}

	.tooltip-content .activity-skulls .skull-text {
		display: block;
		color: rgba(255, 255, 255, 0.7);
		margin-top: 5px;
	}

	.tooltip-content .activity-skulls .guardian-container {
		display: inline-grid;
		margin: 5px;
		/* margin-right: 5px; */
		padding: 5px;
		background: rgba(255, 255, 255, 0.05);
	}

	.tooltip-content .complete-activity {
		color: #5ea16a;
		font-size: 16px;
		font-weight: 200;
	}

	.tooltip-content .step-true {
		width: 10px;
		height: 30px;
		/*border: 3px solid rgba(255, 255, 255, 0.7);*/
		background: #5ea16a;
		margin-left: 4px;
		margin-right: 4px;
		display: inline-block;
	}

	.tooltip-content .step-false {
		width: 10px;
		height: 30px;
		background: #444c55;
		margin-left: 4px;
		margin-right: 4px;
		display: inline-block;
	}

	.tooltip-content .small-image {
		vertical-align: middle;
		margin-right: 5px;
	}

	.tooltip-content .reward-line {
		text-align: left;
	}

	.tooltip-content .reward-icon-false {
		margin-left: 21px;
	}

	.tooltip-content .grimoire-icon {
		background: url(https://www.bungie.net/img/theme/destiny/icons/icon_grimoire_lightgray.png) no-repeat;
		background-size: 11px;
		display: inline-block;
		width: 11px;
		height: 11px;
		margin-right: 5px;
	}

	.tooltip-content .grimoire {
		padding-left: 20px;
		background: url(https://www.bungie.net/img/theme/destiny/icons/icon_grimoire_lightgray.png) 5px 50% no-repeat;
		background-size: 11px;
		font-size: 15px;
		font-weight: bold;
		text-align: left;
	}

	.tooltip-content .total {
		color: rgba(245, 245, 245, 0.7);
		font-size: 11px;
		font-weight: normal;
		z-index: 2;
		position: relative;
	}

	.tooltip-content .title-categories .grimoire .total {
		display: inline;
	}

	.tooltip-content .grimoire-container {
		background-color: rgb(25, 30, 36);
		min-width: 410px;
	}

	.tooltip-content .grimoire-container .grimoire {
		padding: 0 0.75rem;
	}

	.tooltip-content .grimoire-container .remaining {
		padding: 0 0.75rem;
		font-size: 15px;
		font-weight: bold;
	}

	.tooltip-content .grimoire-container .remaining.total {
		color: rgba(245, 245, 245, 0.7);
		font-weight: normal;
	}

	.tooltip-content .bar {
		border: 1px solid rgba(245, 245, 245, 0.1);
		color: rgba(245, 245, 245, 0.8);
		display: inline-table;
		/* width: 250px; */
		vertical-align: middle;
		/* height: 25px; */
		/* padding: 0 0.75rem; */
		padding-top: 5px;
		padding-bottom: 5px;
		position: relative;
		min-width: 105px;
		min-height: 24px;
	}

	.tooltip-content .bar:not(:last-child):not(:last-child) {
		margin-right: 0.5rem;
	}

	.tooltip-content .bar-full {
		background-color: #5da569;
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		max-width: 100%;
		z-index: 1;
	}

	.tooltip-content .grimoire-data {
		z-index: 2;
		position: relative;
	}

	.tooltip-content .grimoire-categories {
		display: inline-block;
		vertical-align: middle;
		color: #fff;
		font-size: 18px;
		font-weight: 200;
		text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
	}

	.tooltip-content .grimoire-text {
		padding: 0 10px;
	}

	.tooltip-content .title-categories .grimoire {
		display: inline-block;
	}

	.tooltip-content .item-stat .bar {
		border: none;
		background: rgb(18, 22, 27);
		width: 100%;
		padding: 0;
		min-height: 10px;
	}

	.tooltip-content .item-stats table {
		width: 100%;
	}

	.tooltip-content #item-objectives table#item-objectives table {
		width: 100%;
	}

	.tooltip-content .item-stat .stat-name {
		padding-right: 8px;
		padding-left: 10px;
		text-align: right;
	}

	.tooltip-content .item-stat .stat-value {
		text-align: left;
		padding-right: 10px;
		padding-left: 5px;
		white-space: nowrap;
	}

	.tooltip-content .item-stat .bar-full {
		background-color: #F5F5F5;
	}

	.tooltip-content .node {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-repeat: no-repeat;
		background-position: center;
		background-origin: padding-box;
		background-size: 80%;
		/*background-color: rgba(255, 255, 255, 0.1);*/
	}

	.tooltip-content .node.node-complete {
		background-color: rgba(255, 255, 255, 0.4);
	}

	.tooltip-content .node.node-selected {
		background-color: #4887ba;
	}

	.tooltip-content .item-nodes table {
		margin: 0 auto;
	}

	.tooltip-content .cost .node {
		width: 24px;
		height: 24px;
	}

	.item-cost table {
		margin: 0 auto;
	}

	.item-stats {
		border-top: 1px solid #999999;
		padding-top: 5px;
		/* border-bottom: 1px solid #999999; */
		padding-bottom: 5px;
		margin: 0 10px;
	}

	.item-stats:not(:last-child) {
		border-bottom: 1px solid #999999;
	}
	/* .item-container {
		display: inline-block;
		position: relative;
		height: 64px;
		font-size: 10px;
		color: black;
		font-weight: bold;
		user-select: none;
		cursor: default;
	}

	.item-container:not(:first-child):not(:last-child) {
		margin-right: 10px;
	} */

	.arc .item-element .text {
		z-index: 2;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAAD0UlEQ…GhI/8A/yrSD8g/ocIBIeG5/APcty0qHRASRlpOarVarfYfSI5SczwdRkcAAAAASUVORK5CYII=);
	}

	.void .item-element .text {
		z-index: 2;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAFY0lEQ…AfrtKKMWp5Fu3KNbzKH/RJ49dvvMVtOkyLu2383//95/kXYBplr9ps3f8AAAAASUVORK5CYII=);
	}

	.solar .item-element .text {
		z-index: 2;
		position: absolute;
		top: 0;
		left: 0;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAAD80lEQ…U1PDAwMH/J5uc83jOhXDyceqMBT8izebAWcFd0dHR0dJTB30Vw2ysBM2yJAAAAAElFTkSuQmCC);
	}

	.arc .item-primary-stat,
	.arc .item-stat-text {
		color: #85C5EC;
	}

	.solar .item-primary-stat,
	.solar .item-stat-text {
		color: #F2721B;
	}

	.void .item-primary-stat,
	.void .item-stat-text {
		color: #B184C5;
	}
	/* .item-light {
		float: right;
	} */
	/* .item-stats {
		position: absolute;
		bottom: 0;
		 width: 100%; 
		padding-left: 2px;
		padding-right: 2px;
		line-height: 1.5;
		text-align: left;
		left: 0;
		right: 0;
	}

	.item-stats-small {
		position: absolute;
		z-index: 1;
		right: 0;
		bottom: 0;
		box-sizing: content-box;
		width: auto;
		min-width: 10px;
		padding: 0 2px;
		background: rgba(255, 255, 255, .9);
	}

	.item-stats-small .item-light {
		float: none;
	} */

	.vendor h1 {
		margin: 0;
		font-weight: 500;
	}

	.item-head.exotic {
		background-color: #CEAE33;
	}

	.item-head.legendary {
		background-color: #522F65;
	}

	.item-head.rare {
		background-color: #5076A3;
	}

	.item-head.uncommon {
		background-color: #366F42;
	}

	.item-head.common {
		color: rgb(30, 36, 43);
		background-color: #C3BCB4;
	}

	.item-head {
		position: relative;
		padding: 5px 18px;
		transition: background-color .5s ease, color .5s ease;
		color: #F5F5F5;
		background: rgba(195, 188, 180, .9);
		min-width: 250px;
	}

	.level-text {
		font-size: 16px;
		display: inline-block;
	}

	.item-description,
	.description {
		font-size: 16px;
		font-style: italic;
		line-height: 20px;
		margin: 7px 0 9px 0;
		white-space: pre-wrap;
		opacity: .8;
		max-width: 350px
	}

	.item-body {
		padding: 5px 18px;
		color: #F5F5F5;
	}

	.item-primary-stat {
		font-size: 50px;
		font-weight: bold;
		line-height: 50px;
		position: relative;
		display: inline-block;
		margin: 0;
	}

	.item-stat-text {
		font-size: 18px;
		font-weight: 400;
		line-height: 22px;
		position: relative;
		top: 15px;
		left: 10px;
		vertical-align: top;
		text-transform: uppercase;
		display: inline;
		transition: color .5s ease;
		color: #F5F5F5;
	}

	.item-image {
		display: block;
		width: 96px;
		height: 96px;
		margin: 0 auto;
	}

	.item-name {
		font-size: 24px;
		font-weight: 500;
		line-height: 1.1em;
		padding-bottom: 10px;
		text-transform: uppercase;
		margin: 0;
	}

	.item-type,
	.item-rarity {
		font-size: 17px;
		font-weight: normal;
		line-height: 20px;
		opacity: .6;
	}

	.item-rarity {
		float: right;
	}
</style>

<script>
	const maxStatRolls = {
		"helmet": 46,
		"gauntlets": 41,
		"chest": 61,
		"leg": 56,
		"class": 25,
		"ghost": 25,
		"artifact": 38
	};

	function getItemCategoryName(itemDef) {
		if (itemDef.itemCategoryHashes.indexOf(38) > -1) {
			return "artifact";
		}
		if (itemDef.itemCategoryHashes.indexOf(39) > -1) {
			return "ghost";
		}
		if (itemDef.itemCategoryHashes.indexOf(45) > -1) {
			return "helmet";
		}
		if (itemDef.itemCategoryHashes.indexOf(46) > -1) {
			return "gauntlets";
		}
		if (itemDef.itemCategoryHashes.indexOf(47) > -1) {
			return "chest";
		}
		if (itemDef.itemCategoryHashes.indexOf(48) > -1) {
			return "leg";
		}
		if (itemDef.itemCategoryHashes.indexOf(49) > -1) {
			return "class";
		}
	}

	function getBonus(light, type) {
		switch (type) {
			case 'helmet':
				return light < 292 ? 15 :
					light < 307 ? 16 :
					light < 319 ? 17 :
					light < 332 ? 18 : 19;
			case 'gauntlets':
				return light < 287 ? 13 :
					light < 305 ? 14 :
					light < 319 ? 15 :
					light < 333 ? 16 : 17;
			case 'chest':
				return light < 287 ? 20 :
					light < 300 ? 21 :
					light < 310 ? 22 :
					light < 319 ? 23 :
					light < 328 ? 24 : 25;
			case 'leg':
				return light < 284 ? 18 :
					light < 298 ? 19 :
					light < 309 ? 20 :
					light < 319 ? 21 :
					light < 329 ? 22 : 23;
			case 'class':
			case 'ghost':
				return light < 295 ? 8 :
					light < 319 ? 9 : 10;
			case 'artifact':
				return light < 287 ? 34 :
					light < 295 ? 35 :
					light < 302 ? 36 :
					light < 308 ? 37 :
					light < 314 ? 38 :
					light < 319 ? 39 :
					light < 325 ? 40 :
					light < 330 ? 41 :
					light < 335 ? 42 : 43;
		}
		// console.warn('item bonus not found', type);
		return 0;
	}

	function getStatQuality(item, itemDef, statHash) {
		var grid = getNodes(item);
		var light = item.primaryStat.value;
		var itemType = getItemCategoryName(itemDef);
		var split = maxStatRolls[itemType];
		var max = 335;
		if (light > max) {
			max = light;
		}
		var statBonus = getBonus(item.primaryStat.value, itemType);
		for (var stat of item.stats) {
			var scaled = 0;
			var statValue = stat.value;
			for (var node of grid) {
				if (node.isActivated) {
					if (stat.statHash === 144602215 && node.nodeStepHash === 1034209669) { // intellect
						statValue = stat.value - statBonus;
					} else if (stat.statHash === 1735777505 && node.nodeStepHash === 1263323987) { // discipline
						statValue = stat.value - statBonus;
					} else if (stat.statHash === 4244567218 && node.nodeStepHash === 193091484) { // strength
						statValue = stat.value - statBonus;
					}
					if (stat.statHash === statHash) {
						return Math.round(100 * parseQuality(statValue, light, max).min / split);
					}
				}
			}
		}
	}

	function fitValue(light) {
		if (light > 300) {
			return (0.2546 * light) - 23.825;
		}
		if (light > 200) {
			return (0.1801 * light) - 1.4612;
		} else {
			return -1;
		}
	}

	function parseQuality(startingStat, startingDefense, endingDefense) {
		var max = Math.floor(fitValue(endingDefense) / fitValue(startingDefense) * (startingStat + 1));
		var min = Math.floor(fitValue(endingDefense) / fitValue(startingDefense) * startingStat);
		return {
			max,
			min
		};
	}

	function getNodes(item, nodes, talentGridHash) {
		let itemData = item;
		var parsedNodes = [];
		var rows = 1;
		var columns = 1;
		if (!nodes && !talentGridHash && !item) {
			return {
				nodes: parsedNodes,
				rows,
				columns
			};
		}
		if (!item) {
			itemData = {};
			itemData.nodes = nodes;
			itemData.talentGridHash = talentGridHash;
		}
		if (itemData.nodes) {
			var grid = DestinyTalentDefinition[itemData.talentGridHash];
			for (var node of itemData.nodes) {
				for (var data of grid.nodes) {
					if ((data.nodeHash === node.nodeHash || (node.nodeHash === 0 && !data.nodeHash)) && !node.hidden && node.stepIndex >
						-1) {
						var step = data.steps[node.stepIndex];
						if (!step) {
							console.log(data, node);
						}
						if (data.column + 1 > columns) {
							columns = data.column + 1;
						}
						if (data.row + 1 > rows) {
							rows = data.row + 1;
						}
						var nodeData = {
							column: data.column + 1 || 1,
							row: data.row + 1 || 1,
							icon: step.icon,
							nodeStepDescription: step.nodeStepDescription,
							nodeStepHash: step.nodeStepHash,
							nodeHash: node.nodeHash,
							stepIndex: step.stepIndex,
							perkHashes: step.perkHashes,
							// activatedAtGridLevel: step.activationRequirement.gridLevel,
							nodeStepName: step.nodeStepName,
							isActivated: node.isActivated,
							state: node.state
						};
						parsedNodes.push(nodeData);
					}
				}
			}
			if (nodes && talentGridHash) {
				return {
					nodes: parsedNodes,
					rows,
					columns
				};
			}
			return parsedNodes;
		}
		return {
			nodes: parsedNodes,
			rows,
			columns
		};
	}
	export default {
		props: ["itemDef", "data", "type"],
		data: function () {
			return {
				// DestinyTalentDefinition: DestinyTalentDefinition,
				// DestinyObjectiveDefinition: DestinyObjectiveDefinition,
				DestinyInventoryItemDefinition: DestinyInventoryItemDefinition,
				DestinySandboxPerkDefinition: DestinySandboxPerkDefinition,
				DestinyStatDefinition: DestinyStatDefinition,
				DestinyDamageTypeDefinition: DestinyDamageTypeDefinition,
				tierType: ["Unknown", "Currency", "Basic", "Common", "Rare", "Legendary", "Exotic"]
			};
		},
		methods: {
			getItemDef(item) {
				return DestinyInventoryItemDefinition[item.itemHash];
			},
			objectivePercentage: function (objective) {
				return Math.round(objective.progress / DestinyObjectiveDefinition[objective.objectiveHash].completionValue * 100);
			},
			objectiveDefinition: function (objective) {
				return DestinyObjectiveDefinition[objective.objectiveHash];
			},
			perkDefinition: function (perk) {
				return DestinySandboxPerkDefinition[perk.perkHash];
			},
			getMaxRollForType: function (itemDef) {
				return maxStatRolls[getItemCategoryName(itemDef)] || 100;
			},
			statWidth: function (stat, itemDef) {
				return stat.value / (1.4 * (maxStatRolls[getItemCategoryName(itemDef)] || 100)) * 100;
			},
			statQuality: function (data, itemDef, statHash) {
				return getStatQuality(data, itemDef, statHash);
			},
			getNodes: function (item, nodes, talentGridHash) {
				return getNodes(item, nodes, talentGridHash);
			},
			getUINodes: function (item, nodes, talentGridHash) {
				let grid = getNodes(item, nodes, talentGridHash);
				let t = {};
				// console.log(nodes,grid.nodes)
				for (let node of grid.nodes) {
					if (node.row > -1 && node.column > -1) {
						if (!t[node.row - 1]) {
							t[node.row - 1] = [];
						}
						t[node.row - 1][node.column - 1] = node;
					}
				}
				return t;
			},
			getColor: function (value) {
				return value === 0 ? "#FFFFFF" :
					value <= 85 ? "#F04242" :
					value <= 90 ? "#F07C42" :
					value <= 95 ? "#F0F042" :
					value <= 99 ? "#42F042" :
					value >= 100 ? "#42D3F0" : "rgba(255, 255, 255, .9)";
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Tooltip.vue?6be44142